import React, { useState, useEffect, useRef } from 'react';

const GenderSelect = props => { 
    const char = useRef()

    const charTip = useRef()
    const [genderWidth,setgenderWidth] = useState(100);
    useEffect(() => {
        function handleResize() {
        var parentHeight = document.getElementsByClassName("ChrPopMidContainer")[0]?.clientHeight;
        setgenderWidth(parentHeight/4.5);
    }
    
        window.addEventListener('resize', handleResize)
    })
    useEffect(() => {
        if(document.getElementsByClassName("ChrPopMidContainer").length>0){
            var parentHeight = document.getElementsByClassName("ChrPopMidContainer")[0]?.clientHeight;
            setgenderWidth(parentHeight/4.5);
        }
      
    }, []);

    useEffect(() => {
        if (props.SelectedGender === props.names) {
            char.current.style.filter = 'saturate(100%)'
            charTip.current.style.display = 'inline-block'
            //setonColor(true)
        } else {
            //setonColor(false)
            char.current.style.filter = 'saturate(0)'
            charTip.current.style.opacity = '0'
        }
    }, [props.SelectedGender])

    return (
        <>
            <div key={ props.ids} className='GenderSelectionStart' onClick={() => {
                if (props.status === 'available') {
                    props.setSelectedGender(props.names)
                    props.setActiveGender(props.names)
                }
            }}

                onMouseLeave={() => {
                    if (props.SelectedGender != props.names) {
                        //setonColor(false)
                        if (props.status === 'available') {
                            char.current.style.filter = 'saturate(0)'
                        }
                        charTip.current.style.opacity = '0'

                    }
                }}

                onMouseEnter={() => {
                    if (props.SelectedGender != props.names) {
                        //setonColor(true)
                        if (props.status === 'available') {
                            char.current.style.filter = 'saturate(100%)'
                        }
                        charTip.current.style.opacity = '1'
                    }
                }}

            >
                < div className='GenderImage' style={{width:genderWidth+"px"}} key={"GenderImage" + props.ids}>
                    <span ref={char} style={{display: props.display}} className='GenderImageInner' dangerouslySetInnerHTML={{ __html: props.ColorSvg }}>
                    </span>
                </div>
                <div className='chartip' ref={charTip} style={{ opacity: '1' }}>{props.names}</div>
            </div>
        </>
    );
};


export default GenderSelect;